import { Branch } from '@/constants';

export const getUniversityOptionsFrom = (
  data: Branch[],
  selectedBranch: string | undefined,
  selectedDegree: string | undefined,
  otherUniversity: string
) => {
  if (!selectedBranch || !selectedDegree) return [];

  const selectedBranchData = data.find((branch: Branch) => branch.branch === selectedBranch);
  if (typeof selectedDegree === 'string' && selectedDegree.toLowerCase() === 'other') {
    return [
      {
        label: otherUniversity,
        value: 'other'
      }
    ];
  }

  if (!selectedBranchData) return [];

  const selectedDegreeData = selectedBranchData.degrees.find(
    degree => degree.degree_name === selectedDegree
  );
  if (!selectedDegreeData) return [];

  return [
    ...selectedDegreeData.universities.map(university => ({
      label: university,
      value: university
    })),
    {
      label: otherUniversity,
      value: 'other'
    }
  ];
};
